export const PATH_DASHBOARD = "/dashboard";
